import React, { useEffect, useMemo, useState } from 'react'
import { Checkbox, Form, Input, Modal, Radio, Select } from 'antd'
import styled from 'styled-components'
import {
  useAddReport,
  useGetMenu,
  useGetScenariosExecutions,
  useGetTaskOption,
  useQueryEmailList,
} from './utils'
import { Message } from '@/components/message'
import { BasSwitch } from '@/components'
import { t } from '@/i18n'

const { useForm } = Form
// const { TextArea } = Input

interface PropsType {
  title: React.ReactNode
  open: boolean
  onCancel: () => void
  updateList: () => void
  scene: string
}

interface TaskItemProps {
  campaign_id: number | string
  task_name: string
}

export interface CreateReportParams {
  assets?: number
  campaign_type: number
  emails?: string
  report_name: string
  task_list: TaskItemProps[]
  template_type: number[]
  [property: string]: any
}

// interface TaskProps {
//   value?: {
//     type: number
//     task: string[]
//   }
//   onChange?: (value: any) => void
// }

enum SceneEnum {
  '钓鱼邮件' = 1,
  '威胁情报' = 2,
  '邮件安全' = 3,
  'web安全' = 4,
  '流量安全' = 5,
  '邮箱收集' = 6,
  '数据防泄漏' = 7,
  '终端安全' = 9,
  '攻击编排' = 10,
  '容器安全' = 11,
}

const CreateModal: React.FC<PropsType> = ({ title, open, onCancel, updateList, scene }) => {
  const [form] = useForm()
  const [emails, setEmails] = useState<string>('')
  const [isSend, setIsSend] = useState<boolean>(false)
  const [tasks, setTasks] = useState<any>()
  const [type, setType] = useState<number>(1)
  const [menu, setMenu] = useState<any>()
  const [scriptOptions, setScriptOptions] = useState<{ label; value; scenario_id }[]>([])
  const [getMenu] = useGetMenu()
  const [taskArr, getTaskArr] = useGetTaskOption()
  const [getScenariosExecutions] = useGetScenariosExecutions()
  const [addReport, addReportLoading] = useAddReport()
  const [queryEmailList, emailList] = useQueryEmailList()

  const onFinish = async values => {
    // 确保 reportFormat 始终是数组类型
    let reportFormat = Array.isArray(values.reportFormat)
      ? values.reportFormat
      : [values.reportFormat].filter(Boolean)

    // 根据场景和任务数量设置报表格式
    if (tasks && tasks.length > 1) {
      reportFormat = [2]
    } else if (scene === '10') {
      reportFormat = [1]
    } else if (scene === '6') {
      reportFormat = [2]
    }

    values.reportFormat = reportFormat

    let taskList: TaskItemProps[] = []
    let scenarioId = ''
    if (scene === '1') {
      taskArr.forEach(item => {
        if (values.phishTask.task.includes(item.id)) {
          taskList.push({ campaign_id: item.id, task_name: item?.name || '' })
        }
      })
    } else if (scene === '10') {
      scriptOptions.forEach(item => {
        if (values.record === item.value) {
          taskList.push({ campaign_id: item.value, task_name: item?.label || '' })
          scenarioId = item.scenario_id || ''
        }
      })
    } else {
      taskArr.forEach(item => {
        if (values?.task?.includes(item.id)) {
          taskList.push({ campaign_id: item.id, task_name: item?.name || '' })
        }
      })
    }

    console.log('values', values)

    let params: CreateReportParams =
      scene === '10'
        ? {
            scenario_id: scenarioId,
            campaign_type: Number(scene),
            emails: isSend ? values.emails.map(item => item).join(',') : '',
            report_name: values.reportName,
            task_list: taskList,
            template_type: values.reportFormat?.map(item => Number(item)),
            include_device_logs: values.include_device_logs,
            from_report: true,
          }
        : {
            campaign_type: Number(scene),
            emails: isSend ? values.emails.map(item => item).join(',') : '',
            report_name: values.reportName,
            task_list: taskList,
            template_type: values.reportFormat?.map(item => Number(item)),
            include_device_logs: values.include_device_logs,
            from_report: true,
          }
    try {
      await addReport(params)
      setEmails('')
      setIsSend(false)
      onCancel()
      updateList()
      form.resetFields()
    } catch (error) {}
  }

  const validateInputLength = (_, value) => {
    if (value && value.length > 50) {
      return Promise.reject(t('输入字符数不能超过50个'))
    }
    return Promise.resolve()
  }

  const taskOptions = useMemo(() => {
    if (form.getFieldValue(['phishTask', 'task'])?.length >= 5) {
      return taskArr.map(item => ({
        label: `${item.name}  ${item.create_time}`,
        value: item.id,
        disabled: form.getFieldValue(['phishTask', 'task'])?.includes(item.id) ? false : true,
      }))
    } else {
      if (scene === '1') {
        return taskArr.map(item => ({
          label: `${item.name}  ${item.create_time}`,
          value: item.id,
        }))
      }
    }
    if (form.getFieldValue(['task'])?.length >= 5) {
      if (scene === '7') {
        return taskArr.map(item => ({
          label: `${item.name}  ${item.create_time}`,
          value: item.id,
          disabled: form.getFieldValue(['task']).includes(item.id) ? false : true,
        }))
      } else {
        return taskArr.map(item => ({
          label: `${item.name}  ${item.create_time}`,
          value: item.id,
          disabled: form.getFieldValue(['task']).includes(item.id) ? false : true,
        }))
      }
    } else {
      if (scene !== '1') {
        if (scene === '7') {
          return taskArr.map(item => ({
            label: `${item.name}  ${item.create_time}`,
            value: item.id,
          }))
        } else if (scene === '4') {
          return taskArr.map(item => ({
            label: `${item.name}-${item?.site_name || ''}-${item.create_time}`,
            value: item.id,
          }))
        } else {
          return taskArr.map(item => ({
            label: `${item.name}  ${item.create_time}`,
            value: item.id,
          }))
        }
      }
    }
  }, [taskArr, form.getFieldValue(['task']), form.getFieldValue(['phishTask', 'task'])])

  useEffect(() => {
    if (open) {
      // 根据场景设置默认报表格式
      let defaultReportFormat: number[] = [2]
      if (scene === '11') {
        defaultReportFormat = [2]
      } else if (scene === '4' || scene === '5' || scene === '9') {
        defaultReportFormat = [2, 3, 4]
      }

      // 重置并设置表单初始值
      form.setFieldsValue({
        reportFormat: defaultReportFormat,
        reportName: '',
        include_device_logs: false,
      })

      queryEmailList({ page: 1, pageSize: 9999 }).catch(_ => {})
      getMenu()
        .then(res => setMenu(res.data.items))
        .catch(_ => {})
      if (scene !== '6' && scene !== '1' && scene !== '10') {
        getTaskArr({ campaign_type: Number(scene) })
          .then()
          .catch(_ => {})
      }
      if (scene === '1') {
        getTaskArr({ campaign_type: Number(scene), second_type: type })
          .then()
          .catch(_ => {})
      }
      if (scene === '10') {
        getScenariosExecutions()
          .then(res => {
            const options = res.data.executionsList.map(item => ({
              label: item.name,
              value: item.id,
              scenario_id: item.scenarioId,
            }))
            setScriptOptions(options)
          })
          .catch(_ => {})
      }
    }
  }, [open, type, scene])

  return (
    <ModalWrapper
      title={title}
      open={open}
      confirmLoading={addReportLoading}
      centered
      onOk={() => form.submit()}
      onCancel={() => {
        onCancel()
        setTasks([])
        setIsSend(false)
        setEmails('')
        form.resetFields()
      }}
    >
      <Form
        form={form}
        layout="horizontal"
        colon={false}
        labelCol={{ flex: scene === '10' ? '130px' : '90px' }}
        wrapperCol={{ flex: 1 }}
        labelAlign="right"
        onFinish={onFinish}
        name="create"
        initialValues={{
          reportName: '',
          reportFormat:
            scene === '11'
              ? [2]
              : scene === '4' || scene === '5' || scene === '9'
              ? [2, 3, 4]
              : [2],
          phishTask: {
            type: 1,
            task: [],
          },
          include_device_logs: false,
        }}
      >
        <Form.Item
          label={t('报表名称')}
          name={'reportName'}
          rules={[
            { required: true, message: t('请输入报表名称') },
            { validator: validateInputLength },
          ]}
        >
          <Input placeholder={t('请输入')} style={{ width: '100%' }} />
        </Form.Item>
        {scene === '10' && (
          <Form.Item
            label={t('关联剧本运行记录')}
            name={'record'}
            rules={[{ required: true, message: t('请选择关联剧本运行记录') }]}
          >
            <Select
              placeholder={t('请选择')}
              options={scriptOptions || []}
              style={{ width: '100%' }}
            />
          </Form.Item>
        )}
        {!['1', '6', '10'].includes(scene) && (
          <Form.Item
            label={t('关联任务')}
            name={'task'}
            rules={[{ required: true, message: t('请选择关联任务') }]}
          >
            <Select
              showArrow
              mode="multiple"
              placeholder={t('请选择')}
              options={taskOptions}
              showSearch
              allowClear
              maxTagCount={1}
              optionFilterProp="label"
              onChange={() => setTasks(form.getFieldValue('task'))}
              style={{ width: '100%' }}
            />
          </Form.Item>
        )}
        {scene === '1' && (
          <Form.Item label={t('关联任务')}>
            <Form.Item
              name={['phishTask', 'type']}
              noStyle
              rules={[{ required: true, message: t('请选择关联任务') }]}
            >
              <Radio.Group
                name="type"
                value={type}
                onChange={e => {
                  setTasks([])
                  form.validateFields(['reportFormat'])
                  form.setFieldValue(['reportFormat'], [2])
                  form.setFieldValue(['phishTask', 'task'], [])
                  setType(e.target.value)
                }}
              >
                <Radio value={1}>{t('钓鱼链接')}</Radio>
                <Radio value={2}>{t('恶意附件')}</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              name={['phishTask', 'task']}
              noStyle
              rules={[{ required: true, message: t('请选择关联任务') }]}
            >
              <Select
                showArrow
                mode="multiple"
                placeholder={t('请选择')}
                options={taskOptions}
                showSearch
                optionFilterProp="label"
                maxTagCount={1}
                onChange={e => {
                  setTasks(e)
                }}
                style={{ marginTop: '12px', width: '100%' }}
              />
            </Form.Item>
          </Form.Item>
        )}
        <Form.Item
          label={t('报表格式')}
          name={'reportFormat'}
          rules={[{ required: true, message: t('请选择报表格式') }]}
        >
          <Checkbox.Group style={{ display: 'flex', flexDirection: 'column' }}>
            {tasks?.length > 1
              ? menu
                  ?.find(item => item.id === Number(scene))
                  ?.template_list?.map(
                    temp => temp.ext_list?.map(ext => ({ label: ext.name, value: ext.id }))[0],
                  )
                  .map(item => (
                    <div
                      key={item.value}
                      style={{
                        display:
                          item.label === 'Excel' && !['1', '6', '7'].includes(scene)
                            ? 'flex'
                            : 'block',
                        alignItems: 'center',
                        marginBottom:
                          item.label === 'Excel' && ['1', '6', '7'].includes(scene) ? 0 : 16,
                        width: '100%',
                      }}
                    >
                      <Checkbox value={item.value}>{item.label}</Checkbox>
                      {item.label === 'Excel' && !['1', '6', '7'].includes(scene) && (
                        <Form.Item name="include_device_logs" noStyle>
                          <Select placeholder={t('请选择模板')} style={{ flex: 1, marginLeft: 8 }}>
                            <Select.Option key="无设备告警日志" value={false}>
                              {t('无设备告警日志')}
                            </Select.Option>
                            <Select.Option key="有设备告警日志" value>
                              {t('有设备告警日志')}
                            </Select.Option>
                          </Select>
                        </Form.Item>
                      )}
                    </div>
                  ))
              : menu
                  ?.find(item => item.id === Number(scene))
                  ?.template_list.flatMap(temp =>
                    temp.ext_list.map(ext => ({ label: ext.name, value: ext.id })),
                  )
                  .filter(item => (tasks?.length > 1 ? item.label !== 'HTML' : true))
                  .map(item => (
                    <div
                      key={item.value}
                      style={{
                        display:
                          item.label === 'Excel' && !['1', '6', '7'].includes(scene)
                            ? 'flex'
                            : 'block',
                        alignItems: 'center',
                        marginBottom:
                          item.label === 'Excel' && ['1', '6', '7'].includes(scene) ? 0 : 16,
                        width: '100%',
                      }}
                    >
                      <Checkbox value={item.value}>{item.label}</Checkbox>
                      {item.label === 'Excel' && !['1', '6', '7'].includes(scene) && (
                        <Form.Item name="include_device_logs" noStyle>
                          <Select placeholder={t('请选择模板')} style={{ flex: 1, marginLeft: 8 }}>
                            <Select.Option key="无设备告警日志" value={false}>
                              {t('无设备告警日志')}
                            </Select.Option>
                            <Select.Option key="有设备告警日志" value>
                              {t('有设备告警日志')}
                            </Select.Option>
                          </Select>
                        </Form.Item>
                      )}
                    </div>
                  ))}
          </Checkbox.Group>
        </Form.Item>
        <div className="send-email-container">
          <Form.Item label={t('发送报表')}>
            <div className="form-content">
              <div className="switch-box">
                <BasSwitch checked={isSend} onChange={checked => setIsSend(checked)} />
                <span className="send-email-info">{t('将报表自动发送到邮箱（不超过10个）')}</span>
              </div>
            </div>
          </Form.Item>
        </div>
        {isSend && (
          <div style={{ marginLeft: scene === '10' ? '130px' : '90px' }}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.emails !== currentValues.emails
              }
            >
              {({ getFieldValue }) => {
                const selectedEmails = getFieldValue('emails') || []
                const isMaxSelected = selectedEmails.length >= 10

                return (
                  <Form.Item
                    name="emails"
                    rules={[
                      { required: true, message: t('请选择发送邮箱') },
                      {
                        validator: (_, value) => {
                          if (value && value.length > 10) {
                            return Promise.reject(t('最多可选择10个邮箱'))
                          }
                          return Promise.resolve()
                        },
                      },
                    ]}
                  >
                    <Select
                      placeholder={t('请选择发送邮箱')}
                      mode="multiple"
                      showArrow
                      allowClear
                      maxTagCount={1}
                      style={{ width: '100%' }}
                    >
                      {emailList.map(item => (
                        <Select.Option
                          key={item.id}
                          value={item.email}
                          disabled={isMaxSelected && !selectedEmails.includes(item.email)}
                        >
                          {item.name}/{item.email}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )
              }}
            </Form.Item>
          </div>
        )}
      </Form>
    </ModalWrapper>
  )
}

export default CreateModal

const ModalWrapper = styled(Modal)`
  .scene {
    margin-bottom: 24px;
    font-size: 14px;
    color: #86909c;

    span {
      font-size: 14px;
      color: #333333;
    }
  }
  .form-content {
    flex: 1;
  }
  .send-email-container {
    margin-bottom: 8px;
    display: flex;
    align-items: flex-start;
    .encoding-type-form-item {
      margin-top: 16px;
    }
    .title {
      font-size: 14px;
      color: #333333;
      margin-right: 20px;
    }
    .send-email-info {
      font-size: 12px;
      color: #666666;
      margin-left: 12px;
      font-family: SourceHanSansCN, SourceHanSansCN;
    }
    .ant-form-item {
      margin-bottom: 0;
    }
  }
  .ant-form-item-label > label {
    font-size: 14px;
    color: #333333;
  }
  .ant-form-item-control {
    flex: 1 !important;
  }
  .send-email-container > .ant-form-item {
    width: 100%;
  }
`
